import React from "react";
import { Typewriter } from "react-simple-typewriter";
import "./Home.css";
import heroBg from "../../../Images/newsRdImg3.jpg";
import FeaturedSection from "../Features/Freatures";
import StatsSection from "../Features/StatsSection";
import Tutorial from '../Features/Tutorials'

const MainContainerSub = () => {
  return (
    <>
    
    <div 
      className="mainContainerSub"
      style={{
        backgroundImage: `url(${heroBg})`,
      }}
    >
      <div className="overlay">
        <p className="tagline">Learn coding the right way</p>
        <h1>Welcome to CareerRestorer</h1>

        {/* Typewriter Effect */}
        <h2 className="subtitle">
          <Typewriter
            words={[
              "Empowering Businesses with IT Solutions",
              "Smart, Scalable & Secure Cloud Services",
              "AI & Machine Learning for Digital Growth",
              "Cybersecurity to Protect Your Business",
              "Transforming Ideas into Digital Reality"
            ]}
            loop={0}          // Infinite loop
            cursor
            cursorStyle="|"
            typeSpeed={60}    // Typing speed
            deleteSpeed={40}  // Deleting speed
            delaySpeed={1500} // Delay before next word
          />
        </h2>

        {/* <p className="description">
          Confused about which IT solution to choose? We’ve got you covered! 
          Explore our cloud, AI, and cybersecurity services to fuel your 
          digital transformation journey.
        </p> */}

        <div className="ctaButtons">
          <button className="primaryBtn"><a href="/services">Explore Services</a></button>
          <button className="secondaryBtn"><a href="/articles">Read Articles</a></button>
        </div>

        {/* Stats Boxes */}
        <div className="statsContainer">
          <div className="statBox">
            <h3>100+</h3>
            <p>Courses</p>
          </div>
          <div className="statBox">
            <h3>500K+</h3>
            <p>Students</p>
          </div>
          <div className="statBox">
            <h3>5.0</h3>
            <p>Rating</p>
          </div>
        </div>
      </div>
    </div>
    <FeaturedSection/>
    <StatsSection/>
    <Tutorial/>
    {/* <Slider/> */}
    
    </>
  );
};

export default MainContainerSub;
